import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

const db = getFirestore();

async function getUserByAuthId(authId) {
  try {
    const q = query(
      collection(db, "users"),
      where("authUID", "==", authId)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return null;
    }

    const doc = querySnapshot.docs[0];

    return {
      id: doc.id,
      ...doc.data(),
    };

  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
}

export default getUserByAuthId;